import PhotoTaker from "./photo-taker";
import Button from "components/button";
import { ASSET_UPLOAD_INPUT_TEST_ID, UPLOAD_FILE_BUTTON_TEST_ID } from "constants/test";
import { supabase, uploadFile } from "libs/supabase";
import { LoadingContext } from "providers/loading";
import { ComponentProps, FunctionComponent, useContext, useRef, useState } from "react";
import { Asset, AssetType } from "types/asset";

interface UploadButtonProps extends ComponentProps<typeof Button> {
  assetType: AssetType;
  onCompletedUpload: () => void;
}

const UploadButton: FunctionComponent<UploadButtonProps> = ({ assetType, onClick, onCompletedUpload, ...buttonProps }) => {
  const ref = useRef<HTMLInputElement>(null);
  const { setLoading } = useContext(LoadingContext);
  const [modelUrl, setModelUrl] = useState<string>();
  return (
    <>
      {!modelUrl ? null : (
        <PhotoTaker
          onPhoto={async (file) => {
            try {
              setLoading(true);
              const url = modelUrl;
              setModelUrl(undefined);
              const image_url = await uploadFile("images", file);
              if (image_url) {
                const newAsset: Asset = { image_url, url, type: assetType };
                await supabase.from("assets").insert(newAsset);
                onCompletedUpload();
              }
              setLoading(false);
            } catch (er) {
              console.log(er);
            }
          }}
          type={assetType}
          onClose={() => setModelUrl(undefined)}
          modelUrl={modelUrl}
        />
      )}
      <input
        data-testid={ASSET_UPLOAD_INPUT_TEST_ID}
        accept=".glb"
        type="file"
        ref={ref}
        className="hidden"
        onChange={async (e) => {
          const target = e.target;
          const files = target.files;
          if (files?.length) {
            setLoading(true);
            const url = await uploadFile(assetType, files[0]);
            if (url) {
              setModelUrl(url);
            }
            setLoading(false);
          }
          target.value = "";
        }}
      ></input>
      <Button data-testid={UPLOAD_FILE_BUTTON_TEST_ID} onClick={() => ref.current?.click()} {...buttonProps}></Button>
    </>
  );
};

export default UploadButton;
